import React from "react";
import { Button, Drawer } from "@blueprintjs/core";
export default function Raw({ json }) {
  const [visible, setVisible] = React.useState(false);
  if (visible) {
    return <Drawer isOpen onClose={() => setVisible(false)} hasBackdrop>
      <div className="bp3-drawer-header">
        <div className="bp3-heading">RAW</div>
      </div>
      <div className="bp3-drawer-body">
        <pre>
          <code>
            {JSON.stringify(json, null, 2)}
          </code>
        </pre>
      </div>
    </Drawer >;
  }
  return <Button minimal onClick={() => setVisible(true)} style={{ float: 'right' }}>raw</Button>;
}
